export default __webpack_public_path__ + "static/media/box-developer-a-b.5a2b07b7.svg";